import React from 'react';
import PropTypes from 'prop-types';
import TextArea from '../../../shared/inputs/TextArea';
import Button from '../../../shared/buttons/Button';
import Select from '../../../shared/inputs/Select';
import ErrorMessage from '../../../shared/message/ErrorMessage';

const TeamInvitationsForm = ({
  value,
  onSave,
  onChange,
  onClose,
  groups,
  groupId,
  updateActiveGroup,
  inviteError,
  unitPrice,
  priceTotal,
  subscription,
}) => {
  return (
    <div>
      <h3>Invite team members</h3>
      <ErrorMessage error={inviteError} />
      <div>
        {subscription && subscription.pay_per_user === 1 && (
          <>
            <div className="alert alert-danger">
              {' '}
              On removing members, please consider your credit will be processed on the next billing cycle and your
              account will be credited. If you have any questions please get in touch with us via sales@everviz.com
            </div>
            <div>
              {' '}
              <b>Current Price:</b> $ {priceTotal}{' '}
            </div>
            <div>
              {' '}
              <b>New Price after invites:</b> ${priceTotal + unitPrice * (value.match(/@/g) || []).length}{' '}
            </div>
          </>
        )}
        <br />
        <label> Group </label>
        <Select
          options={groups}
          value={groups.filter((g) => g.id == groupId)}
          getOptionValue={(option) => option.id}
          getOptionLabel={(option) => option.name}
          className="group-selector"
          clearable={false}
          onChange={updateActiveGroup}
        />
      </div>
      <br />
      <label>Separated by ','</label>
      <TextArea
        name="emailText"
        rows={4}
        placeholder="email_1@example.com, email_2@example.com"
        value={value}
        onChange={onChange}
      />
      <Button extraClass="bulk-action-btn" buttonText="Send" onClick={onSave} />{' '}
      <Button onClick={onClose} buttonClass="bulk-action-btn grey" buttonText="Close" />
    </div>
  );
};

TeamInvitationsForm.propTypes = {
  value: PropTypes.string.isRequired,
  onSave: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  groups: PropTypes.array,
  groupId: PropTypes.string,
  updateActiveGroup: PropTypes.func,
  inviteError: PropTypes.string,
  unitPrice: PropTypes.number,
  priceTotal: PropTypes.number,
  subscription: PropTypes.object,
};

export default TeamInvitationsForm;
